import { api } from "./api";

export interface AnalyticsEventContext {
  file?: number;
  lien?: number;
  lien_file?: number;
  msa?: number;
  cost_projection?: number;
  amended_review_screening?: number;
  background_job?: number;
  claim?: number;
  rre?: number;
  client?: number;
  claimant?: number;
  employer?: number;
  adjuster?: number;
  tpa?: number;
}

export interface AnalyticsEventResponse {
  id: number;
  user: number;
  organization: number;
  type: string;
  url: string | null;
  meta: Record<string, unknown>;
  created: string;
  modified: string;
  // Entity context fields
  file?: number | null;
  lien?: number | null;
  lien_file?: number | null;
  msa?: number | null;
  cost_projection?: number | null;
  amended_review_screening?: number | null;
  background_job?: number | null;
  claim?: number | null;
  rre?: number | null;
  client?: number | null;
  claimant?: number | null;
  employer?: number | null;
  adjuster?: number | null;
  tpa?: number | null;
}

export interface CreateAnalyticsEventRequest {
  url?: string;
  meta?: Record<string, unknown>;
  context?: AnalyticsEventContext;
}

// New types for login/logout tracking
export interface LoginEventData {
  ip_address?: string;
  user_agent?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  meta?: Record<string, any>;
}

export interface UserSession {
  id: number;
  user: number;
  organization: number;
  login_time: string;
  logout_time: string | null;
  session_duration_seconds: number | null;
  duration_minutes: number | null;
  duration_hours: number | null;
  login_ip_address: string | null;
  logout_ip_address: string | null;
  user_agent: string | null;
  is_active: boolean;
  login_analytics_event: number | null;
  logout_analytics_event: number | null;
  created: string;
  modified: string;
}

export const analyticsAPI = api.injectEndpoints({
  endpoints: (build) => ({
    createPageViewEvent: build.mutation<
      AnalyticsEventResponse,
      CreateAnalyticsEventRequest
    >({
      query: ({ url, meta = {}, context = {} }) => ({
        url: `api/v1/analytics-event/pageview/`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          url,
          meta,
          ...context,
        },
      }),
    }),
    createAnalyticsEvent: build.mutation<
      AnalyticsEventResponse,
      CreateAnalyticsEventRequest & { type: string }
    >({
      query: ({ url, meta = {}, context = {}, type }) => ({
        url: `api/v1/analytics-event/`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          type,
          url,
          meta,
          ...context,
        },
      }),
    }),
    // New login/logout tracking endpoints
    recordLogin: build.mutation<UserSession, LoginEventData>({
      query: (data = {}) => ({
        url: `api/v1/user-session/login/`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          user_agent: navigator.userAgent,
          meta: {
            timestamp: new Date().toISOString(),
            page: window.location.pathname,
            ...data.meta,
          },
          ...data,
        },
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useCreatePageViewEventMutation,
  useCreateAnalyticsEventMutation,
  useRecordLoginMutation,
} = analyticsAPI;
